export default __webpack_public_path__ + "static/media/remove.2b87dca0.svg";